// extracted by mini-css-extract-plugin
module.exports = {"buttonBanner":"button_banner-module--button-banner--1_9OF","extraInfo":"button_banner-module--extra-info--1iz_M"};